import React, { useContext } from "react";
import { OverViewWidgetItem } from "../../types";
import { Box } from "@mui/material";
import OverViewWidget from "./OverViewWidget";
import { InnerWidthContext } from "../../contexts";

type OverViewWidgetsProps = {
    overViewWidgetItems: OverViewWidgetItem[];
};

export default function OverViewWidgets({
    overViewWidgetItems,
}: OverViewWidgetsProps) {
    const { isMobile } = useContext(InnerWidthContext);

    return (
        <Box
            sx={{
                display: isMobile ? "inline-flex" : "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "1.5rem",
                width: "100%",
            }}
        >
            {overViewWidgetItems.map(
                (profilWidgetItem: OverViewWidgetItem, idx: number) => (
                    <OverViewWidget
                        key={profilWidgetItem.title + idx}
                        overViewWidgetItem={profilWidgetItem}
                    />
                )
            )}
        </Box>
    );
}
